export default __webpack_public_path__ + "static/femicos-acac5885a465c488ab7b2d1f03040b91.jpg";